
  window.addEventListener('DOMContentLoaded', () => {
    const headings = document.querySelectorAll('.grid .footer-block__heading');
    const collapseMode = "menu_only";

    const handleCollapse = (heading) => {
      // Only handle collapse on mobile
      if (window.innerWidth >= 750) return;

      const content = heading.nextElementSibling;
      if (!content) return;

      heading.classList.toggle('block-collapsed');
      heading.setAttribute('aria-expanded', heading.classList.contains('block-collapsed') ? 'false' : 'true');
      
      // Let CSS handle the transition
      if (heading.classList.contains('block-collapsed')) {
        content.style.maxHeight = '0';
        content.style.visibility = 'hidden';
        content.style.opacity = '0';
        content.style.margin = '0';
        content.style.padding = '0';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.visibility = 'visible';
        content.style.opacity = '1';
        content.style.marginBottom = '3rem';
        //content.style.paddingLeft = heading.closest('.footer-block--menu') ? '1.5rem' : '0';
      }
    };

    const initializeCollapsible = (heading, index) => {
      heading.classList.add('collapsible', 'block-collapsed');
      heading.setAttribute('role', 'button');
      heading.setAttribute('aria-expanded', 'false');
      heading.setAttribute('tabindex', '0');

      const content = heading.nextElementSibling;
      if (!content) return;

      content.setAttribute('id', `footer-block-index-${index}`);
      heading.setAttribute('aria-controls', `footer-block-index-${index}`);

      // Set initial collapsed state only on mobile
      if (window.innerWidth < 750) {
        content.style.maxHeight = '0';
        content.style.visibility = 'hidden';
        content.style.opacity = '0';
        content.style.margin = '0';
        content.style.padding = '0';
      }

      heading.addEventListener('click', () => handleCollapse(heading));
      heading.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleCollapse(heading);
        }
      });
    };

    // Initialize collapsible elements
    headings.forEach((heading, index) => {
      const isMenuBlock = heading.closest('.footer-block--menu');
      const isBrandBlock = heading.closest('.footer-block__brand-info');
      
      if ((collapseMode === 'all' && !isBrandBlock) || (collapseMode === 'menu_only' && isMenuBlock)) {
        initializeCollapsible(heading, index);
      }
    });

    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750) {
        // Reset all collapsible content on desktop
        document.querySelectorAll('.footer-block__details-content').forEach(content => {
          content.style.maxHeight = 'none';
          content.style.visibility = 'visible';
          content.style.opacity = '1';
          content.style.marginBottom = '3rem';
          content.style.paddingLeft = content.closest('.footer-block--menu') ? '0rem' : '0';
        });
      }
    });
  });
    